import { handleActions } from 'redux-actions'
import { importPopupCoursesStatus } from 'actions/importPopupCourses'

const defaultState = {
  open: false
}

const reducer = handleActions(
  {
    [importPopupCoursesStatus]: (
      state,
      {
        payload: {
          data: { status }
        }
      }
    ) => {
      return status
    }
  },
  defaultState
)

export default reducer
